<template>
  <div>
    <PageAllow
      controller="StockTakes"
      :action="isNew ? 'add' : isView ? 'view' : mode"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{
                $t(isNew ? "CRUD.newInfo" : "CRUD.info", [
                  mode == "regularNew"
                    ? $t("StockTakeOrders.regularStakeOrder")
                    : mode == "batchNew"
                    ? $t("StockTakeOrders.batchStockStakeOrder")
                    : $t("StockTakeOrders.ObjectName"),
                ])
              }}
              <v-chip
                v-if="stockTakeOrder.cancel_flg"
                small
                label
                outlined
                class="ms-4 mt-1"
                color="danger"
              >
                {{ $t("CRUD.cancelled") }}
              </v-chip>
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="stockTakeOrder.status | stockTakeOrderStatusColor"
                :text-color="
                  stockTakeOrder.status | stockTakeOrderStatusTextColor
                "
                >{{ stockTakeOrder.status | stockTakeOrderStatusText }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-btn
                  v-if="isNew && mode == 'regularNew' && !next"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="next = true"
                >
                  {{ $t("ProductionPlans.actions.next") }}
                </v-btn>
                <v-btn
                  v-if="preview"
                  small
                  dark
                  outlined
                  color="secondary"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="preview = false"
                >
                  <v-icon x-small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backForModify") }}
                </v-btn>
                <!-- <v-btn
                  v-if="
                    isNew && $permission.permissionAllow('StockTakes', 'add')
                  "
                  :disabled="!stockSelected || !stockSelected.id"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="preview ? doSubmit() : doPreview()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("StockTakeOrders.actions.submitOrder") }}
                </v-btn> -->
                <!-- 保存 -->
                <v-btn
                  v-if="
                    mode == 'stockTake' &&
                    $permission.permissionAllow('StockTakes', 'edit') &&
                    stockTakeOrder.take_type == 1 &&
                    stockTakeOrder.status == 1 &&
                    !preview
                  "
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="doEdit()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("StockTakeOrders.DetailFields.edit") }}
                </v-btn>
                <v-btn
                  v-if="
                    isNew &&
                    $permission.permissionAllow('StockTakes', 'add') &&
                    ((mode == 'regularNew' && next) || mode != 'regularNew')
                  "
                  :disabled="!stockSelected || !stockSelected.id"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("StockTakeOrders.actions.submitOrder") }}
                </v-btn>
                <v-btn
                  v-if="
                    mode == 'stockTake' &&
                    $permission.permissionAllow('StockTakes', 'stockTake')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="preview ? doSubmit() : doPreview()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("StockTakeOrders.actions.submitOrder") }}
                </v-btn>
              </v-sheet>
              <StockTakeOrderActions
                v-if="isView"
                :stock_take_order="stockTakeOrder"
                :showStockTake="
                  stockTakeOrder.actions
                    ? stockTakeOrder.actions.stock_take
                    : false
                "
                :showCancel="
                  stockTakeOrder.actions ? stockTakeOrder.actions.cancel : false
                "
                detail-mode
                @stockTake="mode = 'stockTake'"
              />
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <span
              v-if="
                isNew &&
                ((mode == 'regularNew' && !next) ||
                  (mode != 'regularNew' &&
                    (!stockSelected || !stockSelected.id)))
              "
            >
              <v-row no-gutters class="mt-8">
                <span class="secondary--text">
                  {{ $t("StockTakeOrders.DetailFields.stock_name")
                  }}{{ $t("Global.colon") }}
                </span>
                <SearcherStock
                  noLabel
                  v-model="stockSelected"
                  single-line
                  dense
                  hide-details
                  class="d-inline mb-3"
                  :stock-types="[0]"
                  :wmsSetting="
                    mode == 'new' ? [1] : mode == 'regularNew' ? [0] : null
                  "
                />
              </v-row>
              <v-row
                no-gutters
                class="mt-8"
                v-if="
                  stockSelected && mode == 'regularNew' && stock_take_type == 3
                "
              >
                <span class="secondary--text" style="font-size: 16px">
                  {{ $t("StockTakeOrders.DetailFields.stock_take_type")
                  }}{{ $t("Global.colon") }}
                </span>
                <!-- <v-radio-group
                  v-if="stock_take_type == 1"
                  row
                  hide-details
                  v-model="type"
                  class="d-inline-block mt-n1"
                >
                  <v-radio
                    :label="$t('Stock.stock_take_type.typeOne')"
                    :key="1"
                    :value="1"
                  ></v-radio>
                </v-radio-group>
                <v-radio-group
                  v-if="stock_take_type == 2"
                  row
                  hide-details
                  v-model="type"
                  class="d-inline-block mt-n1"
                >
                  <v-radio
                    :label="$t('Stock.stock_take_type.typeTwo')"
                    :key="2"
                    :value="2"
                  ></v-radio>
                </v-radio-group> -->
                <v-radio-group
                  v-if="stock_take_type == 3"
                  row
                  hide-details
                  v-model="type"
                  class="d-inline-block mt-n1"
                >
                  <v-radio
                    :label="$t('Stock.stock_take_type.typeOne')"
                    :key="1"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    :label="$t('Stock.stock_take_type.typeTwo')"
                    :key="2"
                    :value="2"
                  ></v-radio>
                </v-radio-group>
              </v-row>
            </span>

            <v-row v-else no-gutters class="mt-4 table-style">
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakeOrders.DetailFields.stock_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <SearcherStock
                    v-if="isNew && !preview"
                    noLabel
                    v-model="stockSelected"
                    single-line
                    dense
                    hide-details
                    class="d-inline mt-0 mb-n1"
                    :stock-types="[0]"
                    :wmsSetting="
                      mode == 'new' ? [1] : mode == 'regularNew' ? [0] : null
                    "
                  />
                  <span v-else>
                    {{ stock ? stock.name : "" }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakeOrders.DetailFields.order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ stockTakeOrder.stock_take_code }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakeOrders.DetailFields.created_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ stockTakeOrder.created | formatTime }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakeOrders.DetailFields.operater_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{
                    stockTakeOrder.operate_user
                      ? stockTakeOrder.operate_user.name
                      : ""
                  }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakeOrders.DetailFields.execute_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <SearcherAccountUser
                    v-if="isNew && !preview"
                    noLabel
                    :type="[1, 2]"
                    v-model="executeUser"
                    single-line
                    dense
                    hide-details
                    class="d-inline mt-0 mb-n1"
                    unclearable
                  />
                  <span v-else>
                    {{ executeUser ? executeUser.name : "" }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="type">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakeOrders.DetailFields.stock_take_type")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{
                    type == 1
                      ? $t("Stock.stock_take_type.typeOne")
                      : type == 2
                      ? $t("Stock.stock_take_type.typeTwo")
                      : ""
                  }}
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="!isNew">
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("StockOrderIN.actions.relations") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="relationsHeaders"
                    :items="relations"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.stock_order_code="{ item }">
                      <span
                        class="text-no-wrap"
                        v-if="item.relationsType == 'in'"
                      >
                        <a @click="$router.push('/stock-orders-in/' + item.id)">
                          {{ item.stock_order_code }}
                        </a>
                      </span>
                      <span
                        class="text-no-wrap"
                        v-if="item.relationsType == 'out'"
                      >
                        <a
                          @click="$router.push('/stock-orders-out/' + item.id)"
                        >
                          {{ item.stock_order_code }}
                        </a>
                      </span>
                    </template>
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                    <template v-slot:item.type="{ item }">
                      <v-chip
                        v-if="item.relationsType == 'in'"
                        small
                        label
                        :color="item.type | stockOrderINTypesColor"
                        :text-color="item.type | stockOrderINTypesTextColor"
                      >
                        {{ item.type | stockOrderINTypesText }}
                      </v-chip>
                      <v-chip
                        v-if="item.relationsType == 'out'"
                        small
                        label
                        :color="item.type | stockOrderOUTTypesColor"
                        :text-color="item.type | stockOrderOUTTypesTextColor"
                      >
                        {{ item.type | stockOrderOUTTypesText }}
                      </v-chip>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <span v-if="item.relationsType == 'in'">
                        <v-chip
                          small
                          label
                          :color="item.status | stockOrderINStatusColor"
                          :text-color="
                            item.status | stockOrderINStatusTextColor
                          "
                        >
                          {{ item.status | stockOrderINStatusText }}
                        </v-chip>
                        <br />
                        <v-chip
                          v-if="item.cancel_flg"
                          x-small
                          label
                          outlined
                          color="danger"
                        >
                          {{ $t("CRUD.cancelled") }}
                        </v-chip>
                      </span>
                      <span v-if="item.relationsType == 'out'">
                        <v-chip
                          small
                          label
                          :color="item.status | stockOrderOUTStatusColor"
                          :text-color="
                            item.status | stockOrderOUTStatusTextColor
                          "
                        >
                          {{ item.status | stockOrderOUTStatusText }}
                          <span
                            v-if="
                              item.third_return &&
                              item.third_return.push_platform == 1010
                            "
                          >
                            ({{
                              item.third_return.status
                                | stockOrderOUTThirdStatusText
                            }})
                          </span>
                        </v-chip>
                        <br />
                        <v-chip
                          v-if="item.cancel_flg"
                          x-small
                          label
                          outlined
                          color="danger"
                        >
                          {{ $t("CRUD.cancelled") }}
                        </v-chip>
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-card v-if="isView && false" class="px-4 mt-4">
        <v-row>
          <v-col cols="12" md="12">
            <v-card-title class="ms-n2 py-0">
              {{ $t("StockTakeOrders.DetailFields.stock_take_material_total") }}
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <v-card-title class="py-0 subtitle-1 d-inline-block">
                  {{
                    $t(
                      "StockTakeOrders.DetailFields.stock_take_material_price_total"
                    )
                  }}
                  {{ $t("Global.colon") }}
                  <span class="danger--text">
                    {{ $t("Global.money") }}
                    {{ stockTakeOrder.stock_total_price | formatMoney }}
                  </span>
                </v-card-title>
                <v-card-title class="py-0 subtitle-1 d-inline-block">
                  {{
                    $t(
                      "StockTakeOrders.DetailFields.stock_take_material_num_total"
                    )
                  }}
                  {{ $t("Global.colon") }}
                  <span class="danger--text">
                    {{ stockTakeOrder.stock_total_num | formatTwoDot }}
                  </span>
                </v-card-title>
              </v-sheet>
            </v-card-title>
          </v-col>
        </v-row>
      </v-card>

      <v-card
        :class="
          isNew &&
          ((mode == 'regularNew' && !next) ||
            (mode != 'regularNew' && (!stockSelected || !stockSelected.id)))
            ? 'mt-4 d-none'
            : 'mt-4'
        "
      >
        <!-- 明细/编辑 -->
        <v-data-table
          v-if="(isNew && !preview) || isView || savable"
          id="order_details_table"
          :headers="detailsHeaders"
          :items="stockTakeOrderDetails"
          :search="filter"
          disable-sort
          class="elevation-2 px-4 mt-4 pb-4"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('StockTakeOrders.DetailNoData')"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{ $t("CRUD.details", [$t("StockTakeOrders.ObjectName")]) }}
              </v-toolbar-title>
              <v-spacer />
              <v-btn
                v-if="
                  ($permission.permissionAllow(
                    'StockTakes',
                    'importCommonSave'
                  ) &&
                    mode == 'regularNew') ||
                  ($permission.permissionAllow(
                    'StockTakes',
                    'importBatchSave'
                  ) &&
                    mode == 'batchNew') ||
                  ($permission.permissionAllow(
                    'StockTakes',
                    'importPositionSave'
                  ) &&
                    mode == 'new')
                "
                small
                color="print"
                dark
                @click.stop="ImportDialog = true"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("Import.import", [$t("StockTakeOrders.material")]) }}
              </v-btn>
              <v-btn
                color="primary"
                small
                dark
                class="px-2 me-2 mb-1 mx-1"
                v-if="
                  settings &&
                  (!settings.stock_position_setting ||
                    settings.material_position_bind) &&
                  mode == 'regularNew'
                "
                @click="stockMaterialsDialog = true"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
              </v-btn>
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <v-row no-gutters class="me-n3">
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      stockTakeOrderDetails
                        ? [
                            1,
                            stockTakeOrderDetails.length,
                            stockTakeOrderDetails.length,
                          ]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-row no-gutters>
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:header.new_sys_count="{ header }">
            {{ header.text }}
            <br />
            {{ $t("StockTakeOrders.DetailFields.base_and_stock_unit") }}
          </template>
          <template v-slot:header.new_real_count="{ header }">
            {{ header.text }}
          </template>
          <template
            v-slot:item.stock_material_position.stock_position.bar_code="{
              item,
            }"
          >
            <span class="text-no-wrap caption font-weight-bold">
              {{
                item.isNewMaterial
                  ? item.stock_material_position.Description
                  : item.stock_detail.PositionDescription
              }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{
                item.isNewMaterial
                  ? item.stock_material_position.bar_code
                  : item.stock_material_position.stock_position.bar_code
              }}
            </span>
          </template>
          <template v-slot:item.Description="{ item }">
            {{ item.material_name }}
            <br />
            <span class="caption secondary--text">
              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
              <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard_name }}
              </span>
            </span>
          </template>
          <template v-slot:item.stock_detail.production_date="{ item }">
            <span v-if="item.stock_detail">
              {{ item.stock_detail.production_date | formatDate }}
            </span>
          </template>
          <template v-slot:item.stock_detail.expired_date="{ item }">
            <span v-if="item.stock_detail">
              {{ item.stock_detail.expired_date | formatDate }}
            </span>
          </template>
          <!-- 普通盘点的库存量 -->
          <template v-slot:item.stock_num="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.stock_num }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.stock_current_count | formatTwoDot }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.unit }}
              </span>
            </span>
          </template>
          <template v-slot:item.default_unit_count="{ item }">
            <span>
              {{ item.default_unit_count }}
            </span>
          </template>
          <!-- 批次盘点的库存量 -->
          <template v-slot:item.stock_detail.stock_current="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.stock_detail.stock_current | formatTwoDot }}
              {{ item.stock_detail.unit }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.stock_detail.stock_current | formatTwoDot }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.stock_detail.unit }}
              </span>
            </span>
          </template>
          <!-- 库位批次盘点的库存量 -->
          <template v-slot:item.stock_material_position.stock_num="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.stock_material_position.stock_num }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{
                  item.stock_material_position.stock_position_num | formatTwoDot
                }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.stock_material_position.stock_material.unit }}
              </span>
            </span>
          </template>
          <template v-slot:item.sys_count="{ item }">
            {{ $numberFormatter.formatTwoDot(item.sys_count, true) }}
          </template>
          <template v-slot:item.current_count="{ item }">
            {{ $numberFormatter.formatTwoDot(item.current_count, true) }}
          </template>
          <template v-slot:item.real_count="{ item }">
            <span v-if="isNew">
              <span
                v-if="
                  mode == 'new'
                    ? item.isNewMaterial
                      ? item.standard_detail.rate > 1
                      : item.stock_material_position.stock_material
                          .standard_detail.rate > 1
                    : mode == 'batchNew'
                    ? item.standard_detail.rate > 1
                    : false
                "
              >
                <div class="d-inline-block">
                  <NumberInput v-model="item.real_count_rate" dense>
                    <template v-slot:append>
                      {{
                        mode == "new"
                          ? item.isNewMaterial
                            ? item.standard_detail.unit
                            : item.stock_material_position.stock_material.unit
                          : mode == "batchNew"
                          ? item.standard_detail.unit
                          : ""
                      }}
                    </template>
                  </NumberInput>
                </div>
                <div class="d-inline-block">
                  <NumberInput v-model="item.real_count_default" dense>
                    <template v-slot:append>
                      {{
                        mode == "new"
                          ? item.isNewMaterial
                            ? item.default_standard_detail.unit
                            : item.stock_detail.unit
                          : mode == "batchNew"
                          ? item.default_standard_detail.unit
                          : ""
                      }}
                    </template>
                  </NumberInput>
                </div>
              </span>
              <span v-else>
                <NumberInput v-model="item.real_count" dense>
                  <template v-slot:append>
                    {{
                      mode == "new"
                        ? item.isNewMaterial
                          ? item.standard_detail.unit
                          : item.stock_detail.unit
                        : item.unit
                    }}
                  </template>
                </NumberInput>
              </span>
            </span>
            <span v-else-if="mode == 'stockTake'">
              <!-- <span v-if="$i18n.local == 'zhHans'">
                <NumberInput v-model="item.real_count" dense>
                  <template v-slot:append>
                    {{ item.unit }}
                  </template>
                </NumberInput>
              </span>
              <span v-else>
                <NumberInput v-model="item.real_count" dense />
              </span> -->
              <span
                v-if="
                  item.stock_standard_detail &&
                  item.stock_standard_detail.rate > 1
                "
              >
                <div class="d-inline-block">
                  <NumberInput v-model="item.real_count_rate" dense>
                    <template v-slot:append>
                      {{
                        item.stock_standard_detail
                          ? item.stock_standard_detail.unit
                          : ""
                      }}
                    </template>
                  </NumberInput>
                </div>
                <div class="d-inline-block">
                  <NumberInput v-model="item.real_count_default" dense>
                    <template v-slot:append>
                      {{ item.unit }}
                    </template>
                  </NumberInput>
                </div>
              </span>
              <span v-else>
                <NumberInput v-model="item.real_count" dense>
                  <template v-slot:append>
                    {{
                      item.stock_standard_detail &&
                      item.stock_standard_detail.rate > 1
                        ? item.stock_standard_detail.unit
                        : item.unit
                    }}
                  </template>
                </NumberInput>
              </span>
            </span>
            <span v-else> {{ item.real_count | formatTwoDot }} </span>
          </template>
          <template v-slot:item.real_count_rate="{ item }">
            <span
              v-if="
                item.stock_standard_detail &&
                item.stock_standard_detail.rate > 1
              "
            >
              <div class="d-inline-block">
                <NumberInput v-model="item.real_count_rate" dense>
                  <template v-slot:append>
                    {{ item.stock_standard_detail.unit }}
                  </template>
                </NumberInput>
              </div>
            </span>
          </template>
          <template v-slot:item.real_count_default="{ item }">
            <div class="d-inline-block">
              <NumberInput v-model="item.real_count_default" dense>
                <template v-slot:append>
                  {{ item.unit }}
                </template>
              </NumberInput>
            </div>
          </template>
          <template v-slot:item.stock_take_status="{ item }">
            <span
              v-if="item.stock_detail_ids && item.sys_count > item.real_count"
            >
              <v-btn
                color="orange"
                class="ms-4 mt-1"
                small
                @click.stop="
                  lossStockDetailDialog = true;
                  currentItem = item;
                "
                style="color: white"
              >
                {{ $t("StockTakeOrders.status.stock_take_loss") }}
              </v-btn>
            </span>
            <v-chip
              v-else
              small
              label
              class="ms-4 mt-1"
              :color="
                item.sys_count == item.real_count
                  ? 'grey'
                  : item.sys_count > item.real_count
                  ? 'danger'
                  : item.sys_count < item.real_count
                  ? 'primary'
                  : 'gray'
              "
              text-color="white"
              >{{
                $t(
                  item.sys_count == item.real_count
                    ? "StockTakeOrders.status.stock_take_equality"
                    : item.sys_count > item.real_count
                    ? "StockTakeOrders.status.stock_take_loss"
                    : item.real_count > item.sys_count
                    ? "StockTakeOrders.status.stock_take_profit"
                    : "Status.unkown"
                )
              }}
            </v-chip>
          </template>
          <template v-slot:item.price="{ item }">
            <span>
              {{ $t("Global.money") }}
              {{ item.price | formatMoney }}
            </span>
            <!-- <v-text-field
              v-else
              v-model="item.price"
              single-line
              dense
              hide-details
              type="number"
              min="0"
              :prefix="$t('Global.money')"
              @blur="
                item.price = $numberFormatter.formatWithDotNoMoreThan(
                  item.price,
                  2
                )
              "
              style="max-width: 80px"
            /> -->
          </template>
          <template v-if="isNew" v-slot:item.actions="{ item }">
            <v-btn
              v-if="item.new"
              small
              text
              class="danger--text pa-0"
              @click.stop="del(item)"
            >
              <v-icon>fa-times</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.new_sys_count="{ item }">
            {{
              formatUnit(
                item.sys_count,
                item.stock_standard_detail.rate,
                item.unit,
                item.stock_standard_detail.unit,
                true
              )
            }}
          </template>
          <template v-slot:item.new_real_count="{ item }">
            {{ item.real_count + item.unit }}
          </template>
          <template v-slot:item.base_unit_count="{ item }">
            {{ item.sys_count + item.unit }}
          </template>
          <template v-slot:item.stock_unit_count="{ item }">
            {{
              formatUnit(
                item.sys_count,
                item.stock_standard_detail.rate,
                item.unit,
                item.stock_standard_detail.unit
              )
            }}
          </template>
          <template v-slot:item.stock_take_price="{ item }">
            <span v-if="!item.stock_detail_ids">
              {{ $t("Global.money") + item.price + "/" + item.unit }}
              ({{
                item.status_str + $t("PurchasesDetail.purchaseFields.price")
              }})
            </span>
          </template>
          <template v-slot:item.stock_area="{ item }">
            {{
              item.stock_area
                ? item.stock_area.area_name
                : $t("StockTakeOrders.DetailFields.no_areas")
            }}
          </template>
          <template v-slot:item.stock_position.position_name="{ item }">
            {{
              item.stock_position
                ? item.stock_position.position_name
                : $t("StockTakeOrders.DetailFields.no_position")
            }}
          </template>
          <template v-slot:footer>
            <!-- WMS版 -->
            <v-row
              v-if="
                settings && settings.stock_position_setting && mode == 'new'
              "
              no-gutters
              align="center"
              class="ps-1 text-no-wrap d-flex"
            >
              <!-- 开启库区 -->
              <v-col
                v-if="
                  settings &&
                  settings.stock_area_enable &&
                  stock &&
                  stock.stock_area
                "
                cols="12"
                md="4"
              >
                <SearcherArea
                  v-model="stockAreaSelected"
                  :stock-id="stock_id"
                  label
                />
              </v-col>
              <v-col
                v-if="
                  settings &&
                  settings.stock_area_enable &&
                  stock &&
                  stock.stock_area
                "
                cols="12"
                md="4"
                class="px-3"
              >
                <v-autocomplete
                  v-model="stockPositionSelected"
                  :label="$t('Position.ObjectName')"
                  :items="stockPositionItems"
                  item-value="id"
                  item-text="Description"
                  item-disabled="disabled"
                  clearable
                  return-object
                ></v-autocomplete>
              </v-col>
              <v-col
                v-if="
                  settings &&
                  settings.stock_area_enable &&
                  stock &&
                  stock.stock_area
                "
                cols="12"
                md="4"
                class="px-3"
              >
                <SearcherStockAndStockPositionMaterial
                  v-model="addPositionMaterialSelected"
                  :position-id="stock_position_id"
                  :stock-id="stock_id"
                  label
                />
              </v-col>
              <!-- 未开启库区 -->
              <v-col
                v-if="
                  (settings && !settings.stock_area_enable) ||
                  (stock && !stock.stock_area)
                "
                cols="12"
                md="4"
                class="px-3"
              >
                <SearcherStockPosition
                  v-model="stockPositionSelected"
                  :stock-id="stock_id"
                  :existMaterial="1"
                  label
                />
              </v-col>
              <v-col
                v-if="
                  (settings && !settings.stock_area_enable) ||
                  (stock && !stock.stock_area)
                "
                cols="12"
                md="8"
                class="px-3"
              >
                <SearcherStockAndStockPositionMaterial
                  v-model="addPositionMaterialSelected"
                  :position-id="stock_position_id"
                  :stock-id="stock_id"
                  label
                />
              </v-col>
            </v-row>
            <!-- 非WMS版 -->
            <v-row
              v-if="
                settings &&
                (!settings.stock_position_setting ||
                  settings.material_position_bind) &&
                (mode == 'regularNew' || mode == 'batchNew')
              "
              no-gutters
              align="center"
              class="ps-1 text-no-wrap d-flex"
            >
              <v-col cols="12" md="12" class="px-3">
                <SearcherStockMaterial
                  v-model="selectMaterial"
                  :stock-id="stock_id"
                  :exit-stock-detail="mode == 'batchNew' ? 1 : 0"
                  :disabledItems="disabledItems"
                  :typeFlg="
                    mode == 'batchNew'
                      ? 'stockBatchTakeOrder'
                      : 'stockTakeOrder'
                  "
                  @search="addMaterialSearch = $event"
                  label
                  :status="[1]"
                />
              </v-col>
            </v-row>
          </template>
        </v-data-table>
        <!-- 预览：盘盈 -->
        <v-data-table
          v-if="preview && stockTakeHistoryDetails.stockTakeIns.length"
          id="stock_take_profit_table"
          :headers="profitDetailsHeaders"
          :items="stockTakeHistoryDetails.stockTakeIns"
          :search="filter"
          disable-sort
          class="elevation-2 px-4 mt-4"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('StockTakeOrders.DetailNoData')"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{
                  $t("CRUD.details", [
                    $t("StockTakeOrders.stockTakeInsObjectName"),
                  ])
                }}
              </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <v-row no-gutters class="me-n3">
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      stockTakeHistoryDetails.stockTakeIns
                        ? [
                            1,
                            stockTakeHistoryDetails.stockTakeIns.length,
                            stockTakeHistoryDetails.stockTakeIns.length,
                          ]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-row no-gutters>
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:item.positionDescription="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.positionDescription }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.position_bar_code }}
            </span>
          </template>
          <template v-slot:item.materialDescription="{ item }">
            {{item.material_name}}
            <br />
            <span class="caption secondary--text">
              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
              <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard_name }}
              </span>
            </span>
          </template>
          <template v-slot:item.stock_batch_code>
            {{ $t("StockTakeOrders.PreviewFields.new_stock_batch_text") }}
          </template>
          <template v-slot:item.production_date="{ item }">
            <SearcherDatetime
              v-if="!item.stock_detail_id"
              class="my-n2"
              v-model="item.production_date"
              type="date"
              single-line
              dense
              hide-details
              hide-icon
            >
            </SearcherDatetime>
            <span v-else>{{ item.production_date | formatDate }}</span>
          </template>
          <template v-slot:item.expired_date="{ item }">
            <SearcherDatetime
              v-if="!item.stock_detail_id"
              class="my-n2"
              v-model="item.expired_date"
              type="date"
              single-line
              dense
              hide-details
              hide-icon
            >
            </SearcherDatetime>
            <span v-else>{{ item.expired_date | formatDate }}</span>
          </template>
          <template v-slot:item.in_num_display="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.in_num_display }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.stock_in_num }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.unit }}
              </span>
            </span>
          </template>
          <template v-slot:item.price="{ item }">
            <v-text-field
              v-if="stockTakeOrder.take_type == 1"
              v-model="item.price"
              single-line
              dense
              hide-details
              type="number"
              min="0"
              :prefix="$t('Global.money')"
              @blur="
                item.price = $numberFormatter.formatWithDotNoMoreThan(
                  item.price,
                  2
                )
              "
            />
            <span v-else>
              {{ $t("Global.money") }}
              {{ item.price | formatMoney }}
            </span>
          </template>
        </v-data-table>
        <!-- 预览：盘亏 -->
        <v-data-table
          v-if="preview && stockTakeHistoryDetails.stockTakeOuts.length"
          id="stock_take_loss_table"
          :headers="lossDetailsHeaders"
          :items="stockTakeHistoryDetails.stockTakeOuts"
          :search="filter"
          disable-sort
          class="elevation-2 px-4 mt-4"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('StockTakeOrders.DetailNoData')"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{
                  $t("CRUD.details", [
                    $t("StockTakeOrders.stockTakeOutsObjectName"),
                  ])
                }}
              </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <v-row no-gutters class="me-n3">
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      stockTakeHistoryDetails.stockTakeOuts
                        ? [
                            1,
                            stockTakeHistoryDetails.stockTakeOuts.length,
                            stockTakeHistoryDetails.stockTakeOuts.length,
                          ]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-row no-gutters>
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:item.positionDescription="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.positionDescription }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.position_bar_code }}
            </span>
          </template>
          <template v-slot:item.materialDescription="{ item }">
            {{item.material_name}}
            <br />
            <span class="caption secondary--text">
              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
              <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard_name }}
              </span>
            </span>
          </template>
          <template v-slot:item.production_date="{ item }">
            <span>{{ item.production_date | formatDate }}</span>
          </template>
          <template v-slot:item.expired_date="{ item }">
            <span>{{ item.expired_date | formatDate }}</span>
          </template>
          <template v-slot:item.out_num_display="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.out_num_display }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.stock_out_num }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.unit }}
              </span>
            </span>
          </template>
          <template v-slot:item.price="{ item }">
            <v-text-field
              v-if="stockTakeOrder.take_type == 1"
              v-model="item.price"
              single-line
              dense
              hide-details
              type="number"
              min="0"
              :disabled="
                item.stock_detail_ids && item.stock_detail_ids.length > 0
              "
              :prefix="$t('Global.money')"
              @blur="
                item.price = $numberFormatter.formatWithDotNoMoreThan(
                  item.price,
                  2
                )
              "
            />
            <span v-else>
              {{ $t("Global.money") }}
              {{ item.price | formatMoney }}
            </span>
          </template>
          <template v-slot:item.stock_detail="{ item }">
            <v-btn
              :color="
                item.stock_detail_ids && item.stock_detail_ids.length > 0
                  ? 'orange'
                  : 'primary'
              "
              class="my-1"
              small
              :disabled="item.price && item.price > 0 ? true : false"
              @click.stop="
                stockDetailDialog = true;
                currentItem = item;
              "
            >
              {{ $t("StockTakeOrders.PreviewFields.choose_batch") }}
            </v-btn>
          </template>
        </v-data-table>
      </v-card>

      <SelectLossStockBatchDialog
        v-model="stockDetailDialog"
        :currentItem="currentItem"
        :stock-id="stock_id"
        @stockBatchSeleted="lossStockBatchSelected = $event"
      />

      <lossStockBatchDialog
        v-model="lossStockDetailDialog"
        :currentItem="currentItem"
      />

      <SelectStockBatchDialog
        v-model="stockBatchDialog"
        :stock-position-id="stock_position_id"
        :material-id="material_id"
        :mode="mode"
        :stock-id="stock_id"
        :stock="stock"
        :selectedData="stockBatchSeletedId"
        @stockBatchSeleted="stockBatchSeleted = $event"
      />

      <ImportExcelAlert
        v-model="ImportDialog"
        :objName="
          this.mode == 'regularNew'
            ? $t('StockTakeOrders.ObjectName')
            : this.mode == 'batchNew'
            ? $t('StockTakeOrders.batchStockStakeOrder')
            : this.mode == 'new'
            ? $t('StockTakeOrders.positionStockStakeOrder')
            : $t('StockTakeOrders.ObjectName')
        "
        :stock_id="this.stock_id"
        :mode="this.mode"
        @import="
          excelFile = $event;
          importExcel();
        "
        :type="this.type"
      />
      <DialogAlert
        v-model="stockDetailsNullDialog"
        :title="$t('$vuetify.alert')"
        :message="stockDetailsNullMsg"
        persistent
        @cancel="$router.push('/stock-take-orders')"
      />
      <StockMaterialsSelectsDialog
        v-model="stockMaterialsDialog"
        :stock-id="stock_id"
        :disabledItems="disabledItems"
        :status="[1]"
        :typeFlg="'stockTakeOrder'"
        @confirm="selectMaterials = $event"
        :stock="stockSelected"
      />
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import StockTakeOrderActions from "./plugins/Actions";
import StockTakeOrders from "@/api/stock_take_orders";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherAccountUser from "@/components/plugins/SearcherAccountUser";
import SearcherStockMaterial from "@/components/plugins/SearcherStockMaterial";
import SearcherStockAndStockPositionMaterial from "./plugins/SearchStockAndStockPositionMaterial";
import SearcherArea from "@/components/plugins/SearcherStockArea";
import SearcherStockPosition from "@/components/plugins/SearcherStockPosition";
import StockPosition from "@/api/stock_position";
import Stocks from "@/api/stocks";
import StockDetails from "@/api/stock_details";
import SelectStockBatchDialog from "./plugins/SelectStockBatchDialog";
import SelectLossStockBatchDialog from "./plugins/SelectLossStockBatchDialog";
import lossStockBatchDialog from "./plugins/lossStockBatchDialog";
import NumberInput from "@/components/plugins/NumberInput";
import ImportExcelAlert from "./plugins/ImportExcelAlert";
import DialogAlert from "@/components/plugins/DialogAlert";
import StockMaterials from "@/api/stock_materials";
import StockMaterialsSelectsDialog from "./plugins/StockMaterialsSelectsDialog";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetime,
    StockTakeOrderActions,
    SearcherStock,
    SearcherAccountUser,
    SearcherStockMaterial,
    SearcherStockAndStockPositionMaterial,
    SearcherArea,
    SearcherStockPosition,
    SelectStockBatchDialog,
    SelectLossStockBatchDialog,
    lossStockBatchDialog,
    NumberInput,
    ImportExcelAlert,
    DialogAlert,
    StockMaterialsSelectsDialog,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return (
        !this.preview &&
        (this.mode == "new" ||
          this.mode == "regularNew" ||
          this.mode == "batchNew" ||
          this.mode == "stockTake")
      );
    },
    isNew() {
      return (
        this.mode == "new" ||
        this.mode == "regularNew" ||
        this.mode == "batchNew"
      );
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stockTakeOrders"),
          disabled: false,
          href: "/stock-take-orders",
        },
        {
          text:
            this.mode == "regularNew"
              ? i18n.t("Nav.stockTakeOrderRegularNew")
              : this.mode == "batchNew"
              ? i18n.t("Nav.stockTakeOrderBatchNew")
              : this.isNew
              ? i18n.t("Nav.stockTakeOrderNew")
              : i18n.t("Nav.stockTakeOrderDetail"),
          disabled: true,
        },
      ];
      if (!this.isNew) {
        items.push({
          text:
            this.stockTakeOrder && this.stockTakeOrder.stock_take_code
              ? this.stockTakeOrder.stock_take_code
              : "",
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    // 编辑table-header
    detailsHeaders() {
      var headers = [];
      //库位批次盘点
      if (this.mode == "new") {
        if (
          this.settings &&
          this.settings.stock_area_enable &&
          this.stock &&
          this.stock.stock_area
        ) {
          headers.push({
            text: i18n.t("StockTakeOrders.DetailFields.stock_area_name"),
            align: "center",
            value: "stock_area_name",
          });
        }
        headers.push({
          text: i18n.t("StockTakeOrders.DetailFields.stock_position_bar_code"),
          align: "center",
          value: "stock_material_position.stock_position.bar_code",
        });
      }
      //公共
      headers.push(
        {
          text: i18n.t("StockTakeOrders.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("StockTakeOrders.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("StockTakeOrders.DetailFields.material"),
          align: "start",
          value: "Description",
        }
      );
      if (
        this.settings &&
        this.settings.material_position_bind == 1 &&
        this.stockSelected &&
        this.stockSelected.simple_wms_setting == 1 &&
        (this.stockTakeOrder.take_type == 1 || this.mode == "regularNew")
      ) {
        headers.push(
          {
            text: i18n.t("StockTakeOrders.DetailFields.areas"),
            align: "start",
            value: "stock_area",
          },
          {
            text: i18n.t("StockTakeOrders.DetailFields.position"),
            align: "start",
            value: "stock_position.position_name",
          }
        );
      }
      // 详情
      if (this.isView) {
        // 库位或批次状态
        if (
          this.stockTakeOrder.take_type == 2 ||
          this.stockTakeOrder.take_type == 3
        ) {
          headers.push({
            text: i18n.t("StockTakeOrders.DetailFields.stock_batch_code"),
            align: "center",
            value: "stock_detail.stock_batch_code",
          });
        }
        // 库位或批次状态 && 生产日期
        if (
          this.settings &&
          this.settings.product_date_setting &&
          (this.stockTakeOrder.take_type == 2 ||
            this.stockTakeOrder.take_type == 3)
        ) {
          headers.push(
            {
              text: i18n.t("StockTakeOrders.DetailFields.production_date"),
              align: "center",
              value: "stock_detail.production_date",
            },
            {
              text: i18n.t("StockTakeOrders.DetailFields.expired_date"),
              align: "center",
              value: "stock_detail.expired_date",
            }
          );
        }
        // 已盘点状态
        if (this.isView && this.stockTakeOrder.status == 2) {
          if (this.type != 2) {
            headers.push({
              text: i18n.t("StockTakeOrders.DetailFields.old_stock_count"),
              align: "center",
              value: "new_sys_count",
            });
          }

          if (this.stockTakeOrder.take_type == 1) {
            headers.push({
              text: i18n.t(
                "StockTakeOrders.DetailFields.default_stock_take_count"
              ),
              align: "center",
              value: "new_real_count",
            });
          } else {
            headers.push({
              text: i18n.t(
                "StockTakeOrders.DetailFields.batch_stock_take_count"
              ),
              align: "center",
              value: "new_real_count",
            });
          }
          headers.push({
            text: i18n.t("StockTakeOrders.DetailFields.base_unit"),
            align: "center",
            value: "unit",
          });
          if (this.type != 2) {
            headers.push({
              text: i18n.t("StockTakeOrders.DetailFields.stock_take_price"),
              align: "center",
              value: "stock_take_price",
            });
          }
        }
        // 待盘点状态
        if (this.isView && this.stockTakeOrder.status == 1) {
          if (this.type != 2) {
            headers.push({
              text: i18n.t("StockTakeOrders.DetailFields.current_stock_count"),
              align: "center",
              value: "stock_unit_count",
            });
            headers.push({
              text: i18n.t("StockTakeOrders.DetailFields.default_unit_count"),
              align: "center",
              value: "base_unit_count",
            });
          }
          headers.push({
            text: i18n.t("StockTakeOrders.DetailFields.base_unit"),
            align: "center",
            value: "unit",
          });
        }

        // 已盘点 追加状态
        if (this.isView && this.stockTakeOrder.status == 2) {
          headers.push({
            text: i18n.t("StockTakeOrders.DetailFields.status"),
            align: "center",
            value: "stock_take_status",
          });
        }
      }
      // 盘点时
      if (this.mode == "stockTake") {
        // 库位或批次状态
        if (
          this.stockTakeOrder.take_type == 2 ||
          this.stockTakeOrder.take_type == 3
        ) {
          headers.push({
            text: i18n.t("StockTakeOrders.DetailFields.stock_batch_code"),
            align: "center",
            value: "stock_detail.stock_batch_code",
          });
        }
        // 库位或批次状态 && 生产日期
        if (
          this.settings &&
          this.settings.product_date_setting &&
          (this.stockTakeOrder.take_type == 2 ||
            this.stockTakeOrder.take_type == 3)
        ) {
          headers.push(
            {
              text: i18n.t("StockTakeOrders.DetailFields.production_date"),
              align: "center",
              value: "stock_detail.production_date",
            },
            {
              text: i18n.t("StockTakeOrders.DetailFields.expired_date"),
              align: "center",
              value: "stock_detail.expired_date",
            }
          );
        }
        if (this.type != 2) {
          headers.push({
            text: i18n.t("StockTakeOrders.DetailFields.current_stock_count"),
            align: "center",
            value: "stock_unit_count",
          });
          headers.push({
            text: i18n.t("StockTakeOrders.DetailFields.default_unit_count"),
            align: "center",
            value: "base_unit_count",
          });
        }
        headers.push({
          text: i18n.t("StockTakeOrders.DetailFields.base_unit"),
          align: "center",
          value: "unit",
        });
        // headers.push({
        //   text: i18n.t("StockTakeOrders.DetailFields.batch_stock_take_count"),
        //   align: "center",
        //   value: "real_count",
        // });
        if (this.$i18n.locale != "zhHans") {
          headers.push(
            {
              text: i18n.t(
                "StockTakeOrders.DetailFields.stock_take_count_with_stock_unit"
              ),
              align: "center",
              value: "real_count_rate",
            },
            {
              text: i18n.t(
                "StockTakeOrders.DetailFields.stock_take_count_with_default_unit"
              ),
              align: "center",
              value: "real_count_default",
            }
          );
        } else {
          headers.push({
            text: i18n.t("StockTakeOrders.DetailFields.stock_take_count"),
            align: "right",
            value: "real_count",
            width: "220",
          });
        }
      }
      //新建
      if (this.mode == "regularNew") {
        if (this.type != 2) {
          headers.push(
            {
              text: i18n.t("StockTakeOrders.DetailFields.current_stock_count"),
              align: "start",
              value: "stock_num",
            },
            {
              text: i18n.t("StockTakeOrders.DetailFields.default_unit_count"),
              align: "start",
              value: "default_unit_count",
            }
          );
        }
        //普通盘点
        headers.push({
          text: i18n.t("StockTakeOrders.DetailFields.base_unit"),
          align: "start",
          value: "default_standard_detail.unit",
        });
        // if (this.$i18n.locale != "zhHans") {
        //   headers.push(
        //     {
        //       text: i18n.t(
        //         "StockTakeOrders.DetailFields.stock_take_count_with_stock_unit"
        //       ),
        //       align: "center",
        //       value: "real_count_rate",
        //     },
        //     {
        //       text: i18n.t(
        //         "StockTakeOrders.DetailFields.stock_take_count_with_default_unit"
        //       ),
        //       align: "center",
        //       value: "real_count_default",
        //     }
        //   );
        // } else {
        //   headers.push({
        //     text: i18n.t("StockTakeOrders.DetailFields.stock_take_count"),
        //     align: "center",
        //     value: "real_count",
        //   });
        // }
      } else if (this.mode == "batchNew") {
        //批次盘点
        headers.push({
          text: i18n.t("StockTakeOrders.DetailFields.stock_batch_code"),
          align: "center",
          value: "stock_detail.stock_batch_code",
        });
        if (this.settings && this.settings.product_date_setting) {
          headers.push(
            {
              text: i18n.t("StockTakeOrders.DetailFields.production_date"),
              align: "center",
              value: "stock_detail.production_date",
            },
            {
              text: i18n.t("StockTakeOrders.DetailFields.expired_date"),
              align: "center",
              value: "stock_detail.expired_date",
            }
          );
        }
        headers.push(
          {
            text: i18n.t("StockTakeOrders.DetailFields.current_stock_count"),
            align: "start",
            value: "stock_detail.stock_current_unit",
          },
          {
            text: i18n.t("StockTakeOrders.DetailFields.default_unit_count"),
            align: "start",
            value: "stock_detail.stock_current",
          },
          {
            text: i18n.t("StockTakeOrders.DetailFields.base_unit"),
            align: "start",
            value: "default_standard_detail.unit",
          }
        );
        // if (this.$i18n.locale != "zhHans") {
        //   headers.push(
        //     {
        //       text: i18n.t(
        //         "StockTakeOrders.DetailFields.batch_stock_take_count_with_stock_unit"
        //       ),
        //       align: "center",
        //       value: "real_count_rate",
        //     },
        //     {
        //       text: i18n.t(
        //         "StockTakeOrders.DetailFields.batch_stock_take_count_with_default_unit"
        //       ),
        //       align: "center",
        //       value: "real_count_default",
        //     }
        //   );
        // } else {
        //   headers.push({
        //     text: i18n.t("StockTakeOrders.DetailFields.batch_stock_take_count"),
        //     align: "center",
        //     value: "real_count",
        //   });
        // }
      } else if (this.mode == "new") {
        //库位批次盘点
        headers.push({
          text: i18n.t("StockTakeOrders.DetailFields.stock_batch_code"),
          align: "center",
          value: "stock_detail.stock_batch_code",
        });
        if (this.settings && this.settings.product_date_setting) {
          headers.push(
            {
              text: i18n.t("StockTakeOrders.DetailFields.production_date"),
              align: "center",
              value: "stock_detail.production_date",
            },
            {
              text: i18n.t("StockTakeOrders.DetailFields.expired_date"),
              align: "center",
              value: "stock_detail.expired_date",
            }
          );
        }
        headers.push({
          text: i18n.t(
            "StockTakeOrders.DetailFields.stock_position_batch_stock_count"
          ),
          align: "start",
          value: "stock_material_position.stock_num",
        });
        // if (this.$i18n.locale != "zhHans") {
        //   headers.push(
        //     {
        //       text: i18n.t(
        //         "StockTakeOrders.DetailFields.stock_take_count_with_stock_unit"
        //       ),
        //       align: "center",
        //       value: "real_count_rate",
        //     },
        //     {
        //       text: i18n.t(
        //         "StockTakeOrders.DetailFields.stock_take_count_with_default_unit"
        //       ),
        //       align: "center",
        //       value: "real_count_default",
        //     }
        //   );
        // }
        // else {
        //   headers.push({
        //     text: i18n.t("StockTakeOrders.DetailFields.stock_take_count"),
        //     align: "center",
        //     value: "real_count",
        //   });
        // }
      }
      if (this.isNew) {
        if (this.type != 2) {
          headers.push({
            text: i18n.t("StockTakeOrders.DetailFields.price"),
            align: "start",
            value: "price",
          });
        }
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      if (
        this.mode == "stockTake" &&
        this.$permission.permissionAllow("StockTakes", "edit") &&
        this.stockTakeOrder.take_type == 1 &&
        this.stockTakeOrder.status == 1
      ) {
        headers.push({
          text: i18n.t("StockTakeOrders.DetailFields.status_str"),
          align: "center",
          value: "status_str",
        });
      }

      return headers;
    },
    // 盘盈table-header
    profitDetailsHeaders() {
      var headers = [];
      if (
        this.settings &&
        this.settings.stock_area_enable &&
        this.stock &&
        this.stock.stock_area
      ) {
        headers.push({
          text: i18n.t("StockTakeOrders.PreviewFields.stock_area_name"),
          align: "center",
          value: "stock_area_name",
        });
      }
      // if (this.mode == "new") {
      //   headers.push(
      //     {
      //       text: i18n.t("StockTakeOrders.PreviewFields.stock_position_name"),
      //       align: "center",
      //       value: "positionDescription",
      //     }
      // {
      //   text: i18n.t(
      //     "StockTakeOrders.PreviewFields.stock_position_bar_code"
      //   ),
      //   align: "start",
      //   value: "position_bar_code",
      // }
      //   );
      // }
      headers.push(
        {
          text: i18n.t("StockTakeOrders.PreviewFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("StockTakeOrders.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("StockTakeOrders.PreviewFields.material_name"),
          align: "start",
          value: "materialDescription",
        }
      );
      headers.push(
        {
          text: i18n.t("StockTakeOrders.PreviewFields.profit_num"),
          align: "center",
          value: "default_in_num_display",
        },
        {
          text: i18n.t("StockTakeOrders.DetailFields.base_unit"),
          align: "center",
          value: "default_unit",
        }
      );
      if (this.mode == "new" || this.mode == "batchNew") {
        headers.push({
          text: i18n.t("StockTakeOrders.PreviewFields.stock_batch_code"),
          align: "start",
          value: "stock_batch_code",
        });
      }
      headers.push({
        text: i18n.t("StockTakeOrders.PreviewFields.base_price"),
        align: "center",
        value: "price",
        width: "200",
      });
      if (this.settings && this.settings.product_date_setting) {
        headers.push(
          {
            text: i18n.t("StockTakeOrders.PreviewFields.production_date"),
            align: "center",
            value: "production_date",
          },
          {
            text: i18n.t("StockTakeOrders.PreviewFields.expired_date"),
            align: "center",
            value: "expired_date",
          }
        );
      }
      return headers;
    },
    // 盘亏table-header
    lossDetailsHeaders() {
      var headers = [];
      if (
        this.settings &&
        this.settings.stock_area_enable &&
        this.stock &&
        this.stock.stock_area
      ) {
        headers.push({
          text: i18n.t("StockTakeOrders.PreviewFields.stock_area_name"),
          align: "center",
          value: "stock_area_name",
        });
      }
      if (this.mode == "new") {
        headers.push(
          {
            text: i18n.t("StockTakeOrders.PreviewFields.stock_position_name"),
            align: "center",
            value: "positionDescription",
          }
          // {
          //   text: i18n.t(
          //     "StockTakeOrders.PreviewFields.stock_position_bar_code"
          //   ),
          //   align: "start",
          //   value: "position_bar_code",
          // }
        );
      }
      headers.push(
        {
          text: i18n.t("StockTakeOrders.PreviewFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("StockTakeOrders.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("StockTakeOrders.PreviewFields.material_name"),
          align: "start",
          value: "materialDescription",
        }
      );
      headers.push(
        {
          text: i18n.t("StockTakeOrders.PreviewFields.loss_num"),
          align: "center",
          value: "default_out_num_display",
        },
        {
          text: i18n.t("StockTakeOrders.DetailFields.base_unit"),
          align: "center",
          value: "default_unit",
        }
      );
      if (this.mode == "batchNew") {
        headers.push({
          text: i18n.t("StockTakeOrders.PreviewFields.stock_batch_code"),
          align: "start",
          value: "stock_batch_code",
        });
      }

      if (
        this.settings &&
        this.settings.product_date_setting &&
        this.isNew &&
        this.mode != "regularNew"
      ) {
        headers.push(
          {
            text: i18n.t("StockTakeOrders.PreviewFields.production_date"),
            align: "center",
            value: "production_date",
          },
          {
            text: i18n.t("StockTakeOrders.PreviewFields.expired_date"),
            align: "center",
            value: "expired_date",
          }
        );
      }
      headers.push({
        text: i18n.t("StockTakeOrders.PreviewFields.base_price"),
        align: "center",
        value: "price",
        width: "200",
      });
      if (
        this.stockTakeOrder.take_type == "1" &&
        this.settings &&
        this.settings.stock_take_out_from_batch
      ) {
        headers.push({
          text: i18n.t("StockTakeOrders.PreviewFields.choose_batch"),
          align: "center",
          value: "stock_detail",
          width: "100",
        });
      }

      return headers;
    },
    stock_id() {
      return this.stockSelected
        ? this.stockSelected.id
        : this.stockTakeOrder
        ? this.stockTakeOrder.stock_id
        : null;
    },
    stock_area_id() {
      return this.stockAreaSelected ? this.stockAreaSelected.id : null;
    },
    stock_position_id() {
      return this.stockPositionSelected ? this.stockPositionSelected.id : null;
    },
    material_id() {
      return this.addPositionMaterialSelected
        ? this.addPositionMaterialSelected.id
        : this.addMaterial
        ? this.addMaterial.material_id
        : null;
    },
    operate_user_id() {
      return this.accountUser ? this.accountUser.id : null;
    },
    stockPositionItems() {
      return this.stockPosition.map((position) => {
        var Description = i18n.t("MovePositionOrder.DetailFields.position", [
          position.position_code,
          position.position_name,
        ]);
        if (this.stock && this.stock.position_name_display) {
          if (this.stock.position_name_display.indexOf(2) > -1) {
            Description = position.position_name;
          }
          if (
            this.stock.position_name_display.indexOf(4) > -1 &&
            position.stock_roadway
          ) {
            Description = position.stock_roadway.code + " - " + Description;
          }
          if (
            this.stock.position_name_display.indexOf(3) > -1 &&
            position.stock_area
          ) {
            Description = position.stock_area.area_name + " - " + Description;
          }
        }
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.position_id == position.id
            )
          : false;
        return Object.assign({}, position, { Description, disabled });
      });
    },
    relationsHeaders: () => [
      {
        text: i18n.t("StockTakeOrders.Fields.relation_code"),
        align: "start",
        sortable: false,
        value: "stock_order_code",
      },
      {
        text: i18n.t("StockOrderIN.Fields.stock_in_obj_name"),
        align: "start",
        class: "text-no-wrap",
        sortable: false,
        value: "obj_name",
      },
      {
        text: i18n.t("StockTakeOrders.Fields.relation_type"),
        align: "start",
        sortable: false,
        value: "type",
      },
      {
        text: i18n.t("StockOrderIN.Fields.status"),
        align: "start",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("Order.RelationFields.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
      {
        text: i18n.t("Order.RelationFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    panels: [0],
    tab: null,
    filter: "",
    mode: "",
    preview: false,
    stockTakeOrder: {},
    stockTakeOrderDetails: [],
    stockSelected: null,
    stock: null,
    executeUser: null,
    stockPosition: [],
    stockPositionSelected: null,
    stockAreaSelected: null,
    selectMaterial: null,
    selectMaterials: [],
    addMaterial: null,
    addMaterials: null,
    addMaterialSearch: "",
    addPositionMaterialSelected: null,
    addPositionMaterialSearch: "",
    stockBatchDialog: false,
    stockBatchSeleted: [],
    stockBatchSeletedId: [],
    lossStockBatchSelected: [],
    stockTakeHistoryDetails: [],
    disabledItems: [],
    ImportDialog: false,
    excelFile: null,
    stockDetailsNullDialog: false,
    relations: [],
    stockDetailsNullMsg: "",
    currentItem: null,
    stockDetailDialog: false,
    lossStockDetailDialog: false,
    stockMaterialsDialog: false,
    next: false,
    stock_take_type: "",
    type: 0,
  }),

  mounted() {
    if (this.$route.path.startsWith("/stock-take-orders/regular-new")) {
      this.mode = "regularNew";
    } else if (this.$route.path.startsWith("/stock-take-orders/batch-new")) {
      this.mode = "batchNew";
    } else if (this.$route.path.startsWith("/stock-take-orders/new")) {
      this.mode = "new";
    } else {
      this.mode = this.$route.params.mode;
      if (this.mode)
        this.$router.replace("/stock-take-orders/" + this.$route.params.id);
    }
  },

  methods: {
    getStockInsFromAPI() {
      StockTakeOrders.fetchOne(this.$route.params.id, { readonly: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stockTakeOrder = response.data.stock_take_history;
            if (
              this.stockTakeOrder.invalid_inventory_flg &&
              this.stockTakeOrder.status != 2
            ) {
              this.stockDetailsNullDialog = true;
              this.stockDetailsNullMsg = i18n.t(
                "StockTakeOrders.stockDetailInvalidInventory"
              );
            }
            this.stockTakeOrder.stock_take_history_details.forEach((detail) => {
              if (detail.unit != detail.stock_standard_detail.unit)
                detail.real_count_default = detail.real_count;
            });
            this.relations = [];
            if (JSON.stringify(response.data.stock_in) != "[]") {
              response.data.stock_in.relationsType = "in";
              this.relations.push(response.data.stock_in);
            }
            if (JSON.stringify(response.data.stock_out) != "[]") {
              response.data.stock_out.relationsType = "out";
              this.relations.push(response.data.stock_out);
            }
            if (this.stockTakeOrder.type) {
              this.type = this.stockTakeOrder.type;
            }
            //待盘点状态下，初始化盘点量
            // if (
            //   this.stockTakeOrder.status == 1 &&
            //   this.stockTakeOrder.stock_take_history_details.length
            // ) {
            //   this.stockTakeOrder.stock_take_history_details =
            //     this.stockTakeOrder.stock_take_history_details.map((detail) => {
            //       if (detail.real_count == 0) {
            //         detail.real_count = null;
            //       }
            //       return detail;
            //     });
            // }
          }
        }.bind(this)
      );
    },
    del(item) {
      this.stockTakeOrderDetails.splice(
        this.stockTakeOrderDetails.findIndex((detail) =>
          item.id
            ? item.id == detail.id
            : item.material_id == detail.material_id &&
              (item.new ? item.new == detail.new : detail.new == 0)
        ),
        1
      );
      this.disabledItems.splice(
        this.disabledItems.findIndex(
          (dis) => item.material_id == dis.material_id
        )
      );
    },
    previewMethod(data) {
      if (this.mode == "stockTake") return StockTakeOrders.addPreview(data);
      else if (this.mode == "edit") return "edit";
    },
    submitMethod(data) {
      if (this.isNew) {
        return StockTakeOrders.addStockTake(data);
      } else if (
        this.mode == "stockTake" &&
        this.stock &&
        this.stock.wms_setting == 1
      ) {
        return StockTakeOrders.positionStockTake(data);
      } else if (
        this.mode == "stockTake" &&
        this.stock &&
        this.stock.wms_setting == 0
      ) {
        return StockTakeOrders.stockTake(data);
      }
    },
    //新增预览
    doPreview() {
      this.$store.dispatch("fullscreenLoading");
      var previewDetails = this.newSubmitData();
      if (previewDetails) {
        this.previewMethod(previewDetails).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stockTakeHistoryDetails =
                response.data.stock_take_history.stock_take_history_details;
              if (
                this.stockTakeHistoryDetails.stockTakeIns.length ||
                this.stockTakeHistoryDetails.stockTakeOuts.length
              ) {
                this.preview = true;
                this.stockTakeHistoryDetails.stockTakeIns.forEach(
                  (stock_take_ins) => {
                    //商品名称格式化
                    stock_take_ins.materialDescription = i18n.t(
                      this.settings
                        ? this.settings.material_name_display_type == 4
                          ? "Material.nameWithCodeAndStandard"
                          : this.settings.material_name_display_type == 3
                          ? "Material.materialNameWithCodeAndStandard"
                          : this.settings.material_name_display_type == 2
                          ? "Material.materialNameWithCode"
                          : "Material.materialName"
                        : "Material.materialName",
                      [
                        stock_take_ins.material_code,
                        stock_take_ins.material_name,
                        stock_take_ins.standard_name,
                      ]
                    );
                    //库位名称格式化
                    //库位名称格式化
                    var positionDescription = i18n.t(
                      "MovePositionOrder.DetailFields.position",
                      [
                        stock_take_ins.position_code,
                        stock_take_ins.position_name,
                      ]
                    );
                    if (this.stock && this.stock.position_name_display) {
                      if (this.stock.position_name_display.indexOf(2) > -1) {
                        positionDescription = stock_take_ins.position_name;
                      }
                      if (
                        this.stock.position_name_display.indexOf(4) > -1 &&
                        stock_take_ins.stock_roadway
                      ) {
                        positionDescription =
                          stock_take_ins.stock_roadway.code +
                          " - " +
                          positionDescription;
                      }
                      if (
                        this.stock.position_name_display.indexOf(3) > -1 &&
                        stock_take_ins.stock_area
                      ) {
                        positionDescription =
                          stock_take_ins.stock_area.area_name +
                          " - " +
                          positionDescription;
                      }
                    }
                    stock_take_ins.positionDescription = positionDescription;
                  }
                );
                this.stockTakeHistoryDetails.stockTakeOuts.forEach(
                  (stock_take_outs) => {
                    //商品名称格式化
                    stock_take_outs.materialDescription = i18n.t(
                      this.settings
                        ? this.settings.material_name_display_type == 3
                          ? "Material.materialNameWithCodeAndStandard"
                          : this.settings.material_name_display_type == 2
                          ? "Material.materialNameWithCode"
                          : "Material.materialName"
                        : "Material.materialName",
                      [
                        stock_take_outs.material_code,
                        stock_take_outs.material_name,
                        stock_take_outs.standard_name,
                      ]
                    );
                    //库位名称格式化
                    var positionDescription = i18n.t(
                      "MovePositionOrder.DetailFields.position",
                      [
                        stock_take_outs.position_code,
                        stock_take_outs.position_name,
                      ]
                    );
                    if (this.stock && this.stock.position_name_display) {
                      if (this.stock.position_name_display.indexOf(2) > -1) {
                        positionDescription = stock_take_outs.position_name;
                      }
                      if (
                        this.stock.position_name_display.indexOf(4) > -1 &&
                        stock_take_outs.stock_roadway
                      ) {
                        positionDescription =
                          stock_take_outs.stock_roadway.code +
                          " - " +
                          positionDescription;
                      }
                      if (
                        this.stock.position_name_display.indexOf(3) > -1 &&
                        stock_take_outs.stock_area
                      ) {
                        positionDescription =
                          stock_take_outs.stock_area.area_name +
                          " - " +
                          positionDescription;
                      }
                    }
                    stock_take_outs.positionDescription = positionDescription;
                  }
                );
                this.$store.dispatch("fullscreenLoadingStop");
              } else {
                this.submitMethod(previewDetails)
                  .then(
                    function (response) {
                      if (response.data.status.isOK()) {
                        this.$router.push("/stock-take-orders");
                      }
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  )
                  .catch(
                    function () {
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  );
              }
            }
          }.bind(this)
        );
      } else {
        this.$store.dispatch("fullscreenLoadingStop");
      }
    },
    //新增提交
    doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      if (this.isNew) {
        var submitData = this.newSubmitData();
        if (submitData) {
          this.submitMethod(submitData)
            .then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$router.push("/stock-take-orders");
                }
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            )
            .catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
        } else {
          this.$store.dispatch("fullscreenLoadingStop");
        }
      } else if (this.mode == "stockTake") {
        var stockTakeArr = this.newSubmitData();
        if (stockTakeArr) {
          this.submitMethod(stockTakeArr)
            .then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$router.push("/stock-take-orders");
                }
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            )
            .catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
        } else {
          this.$store.dispatch("fullscreenLoadingStop");
        }
      }
    },
    doEdit() {
      this.$store.dispatch("fullscreenLoading");
      var submitData = this.newSubmitData();
      var details = submitData.stock_take_history_details.map((detail) => {
        return { id: detail.id, real_count: detail.real_count };
      });
      StockTakeOrders.editStockTake({
        id: submitData.stock_take_id,
        stock_take_history_details: details,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/stock-take-orders");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    newSubmitData() {
      //过滤没有盘点量的详情
      var submitOrderDetails = {
        stock_take_id: this.stockTakeOrder.id,
        stock_id: this.stock_id,
        operate_user_id: this.operate_user_id,
        stock_take_history_details: [],
      };
      if (this.mode == "regularNew") {
        submitOrderDetails = Object.assign({}, submitOrderDetails, {
          type: this.type,
        });
      }
      if (this.isNew) {
        this.stockTakeOrderDetails.forEach((order_detail) => {
          let newData = [];
          if (this.isNew && this.mode == "new") {
            if (order_detail.isNewMaterial) {
              newData = Object.assign(
                {},
                {
                  material_code: order_detail.material_code,
                  price: order_detail.price,
                  stock_position_id: order_detail.stock_material_position.id,
                }
              );
            } else {
              newData = Object.assign(
                {},
                {
                  material_code: order_detail.material_code,
                  stock_detail_id: order_detail.stock_detail.id,
                  price: order_detail.price,
                  stock_position_id:
                    order_detail.stock_material_position.stock_position_id,
                }
              );
            }
          } else if (this.isNew && this.mode == "batchNew") {
            newData = Object.assign(
              {},
              {
                material_code: order_detail.material_code,
                stock_detail_id: order_detail.stock_detail.id,
                price: order_detail.price,
              }
            );
          } else if (this.isNew && this.mode == "regularNew") {
            newData = Object.assign(
              {},
              {
                material_code: order_detail.material_code,
                price: order_detail.price,
              }
            );
          }

          //判断是否开启生产过期日期
          if (this.settings && this.settings.product_date_setting) {
            if (
              (this.mode == "new" && !order_detail.isNewMaterial) ||
              this.mode == "batchNew"
            ) {
              newData.production_date =
                order_detail.stock_detail.production_date;
              newData.expired_date = order_detail.stock_detail.expired_date;
            } else if (this.mode == "regularNew") {
              let stock_take_in = this.stockTakeHistoryDetails.stockTakeIns
                ? this.stockTakeHistoryDetails.stockTakeIns.find(
                    (inDetail) =>
                      inDetail.material_code == order_detail.material_code
                  )
                : null;
              if (stock_take_in) {
                newData.production_date = stock_take_in.production_date;
                newData.expired_date = stock_take_in.expired_date;
              }
            }
          }
          //判断是否开启库区
          if (
            this.settings &&
            this.settings.stock_area_enable &&
            this.stock &&
            this.stock.stock_area
          ) {
            submitOrderDetails.stock_area_id = order_detail.stock_area_id;
          }

          submitOrderDetails.stock_take_history_details.push(newData);
        });
        return submitOrderDetails;
      } else if (this.preview && this.mode == "stockTake") {
        //提交盘点
        let orderDetails = [];
        //盘盈
        this.stockTakeHistoryDetails.stockTakeIns.map((detail) => {
          //添加详情
          let newData = {
            id: detail.id,
            real_count: detail.real_count,
            material_code: detail.material_code,
            price: detail.price,
          };
          if (detail.stock_position_id) {
            newData = Object.assign(newData, {
              stock_position_id: detail.stock_position_id,
            });
          }
          if (detail.stock_detail_id) {
            newData = Object.assign(newData, {
              stock_detail_id: detail.stock_detail_id,
            });
          }

          //判断是否开启生产过期日期
          if (this.settings && this.settings.product_date_setting) {
            newData = Object.assign(newData, {
              production_date: detail.production_date,
              expired_date: detail.expired_date,
            });
          }
          //判断是否开启库区
          if (
            this.settings &&
            this.settings.stock_area_enable &&
            this.stock &&
            this.stock.stock_area
          ) {
            submitOrderDetails.stock_area_id = detail.stock_area_id;
          }

          orderDetails.push(newData);
        });
        //盘亏
        this.stockTakeHistoryDetails.stockTakeOuts.map((detail) => {
          let newData = {
            id: detail.id,
            real_count: detail.real_count,
            material_code: detail.material_code,
            price: detail.price,
          };
          if (detail.stock_position_id) {
            newData = Object.assign(newData, {
              stock_position_id: detail.stock_position_id,
            });
          }
          if (detail.stock_detail_id) {
            newData = Object.assign(newData, {
              stock_detail_id: detail.stock_detail_id,
            });
          }
          if (detail.stock_detail_ids) {
            newData = Object.assign(newData, {
              stock_detail_ids: detail.stock_detail_ids,
            });
          }

          //判断是否开启生产过期日期
          if (this.settings && this.settings.product_date_setting) {
            newData = Object.assign(newData, {
              production_date: detail.production_date,
              expired_date: detail.expired_date,
            });
          }
          //判断是否开启库区
          if (
            this.settings &&
            this.settings.stock_area_enable &&
            this.stock &&
            this.stock.stock_area
          ) {
            submitOrderDetails.stock_area_id = detail.stock_area_id;
          }

          orderDetails.push(newData);
        });
        // 整理盘平的商品
        this.stockTakeOrderDetails.map((d) => {
          if (!orderDetails.find((e) => e.id == d.id)) {
            //计算总盘点量
            let real_count = "";
            if (d.real_count_rate) {
              real_count = d.real_count_rate * d.stock_standard_detail.rate;

              if (d.real_count_default) real_count += d.real_count_default;
            } else if (d.real_count || d.real_count_default) {
              d.real_count
                ? (real_count = d.real_count)
                : d.real_count_default
                ? (real_count = d.real_count_default)
                : "";
            }

            //添加详情
            let newData = {
              id: d.id,
              real_count: real_count,
              material_code: d.material_code,
            };
            if (d.stock_position_id) {
              newData = Object.assign(newData, {
                stock_position_id: d.stock_position_id,
              });
            }
            if (d.stock_detail_id) {
              newData = Object.assign(newData, {
                stock_detail_id: d.stock_detail_id,
              });
            }

            //判断是否开启生产过期日期
            if (this.settings && this.settings.product_date_setting) {
              newData = Object.assign(newData, {
                production_date: d.production_date,
                expired_date: d.expired_date,
              });
            }
            //判断是否开启库区
            if (
              this.settings &&
              this.settings.stock_area_enable &&
              this.stock &&
              this.stock.stock_area
            ) {
              submitOrderDetails.stock_area_id = d.stock_area_id;
            }

            orderDetails.push(newData);
          }
        });
        submitOrderDetails.stock_take_history_details = orderDetails;
        return submitOrderDetails;
      } else {
        //提交到预览
        let orderDetails = this.stockTakeOrderDetails.filter(
          (detail) =>
            detail.real_count ||
            detail.real_count === 0 ||
            detail.real_count_rate ||
            detail.real_count_default
        );
        if (orderDetails.length) {
          orderDetails.forEach((order_detail) => {
            //计算总盘点量
            let real_count = "";
            if (
              order_detail.unit != order_detail.stock_standard_detail.unit &&
              (order_detail.real_count_rate === "" ||
                order_detail.real_count_rate == undefined) &&
              (order_detail.real_count_default === "" ||
                order_detail.real_count_default == undefined)
            ) {
              // 存在大单位，但是大小单位都未填的情况
              real_count = order_detail.current_count;
            } else if (
              order_detail.unit != order_detail.stock_standard_detail.unit &&
              order_detail.real_count_rate != undefined
            ) {
              // 存在大单位，填写了大单位的情况
              real_count =
                order_detail.real_count_rate *
                order_detail.stock_standard_detail.rate;

              if (order_detail.real_count_default) {
                real_count += order_detail.real_count_default;
              }
            } else if (
              order_detail.unit != order_detail.stock_standard_detail.unit &&
              (order_detail.real_count_rate === "" ||
                order_detail.real_count_rate == undefined) &&
              (order_detail.real_count_default != "" ||
                order_detail.real_count_default != undefined)
            ) {
              // 存在大单位，只填写了小单的情况
              if (
                order_detail.stock_standard_detail &&
                order_detail.stock_standard_detail.rate == 1
              ) {
                real_count = order_detail.real_count;
              } else {
                real_count = order_detail.real_count_default;
              }
            } else if (
              order_detail.unit == order_detail.stock_standard_detail.unit
            ) {
              // 不存在大单位的情况
              real_count = order_detail.real_count;
            }

            //添加详情
            let newData = {
              id: order_detail.id,
              real_count: real_count,
              material_code: order_detail.material_code,
            };
            if (order_detail.stock_position_id) {
              newData = Object.assign(newData, {
                stock_position_id: order_detail.stock_position_id,
              });
            }
            if (order_detail.stock_detail_id) {
              newData = Object.assign(newData, {
                stock_detail_id: order_detail.stock_detail_id,
              });
            }

            //判断是否开启生产过期日期
            if (this.settings && this.settings.product_date_setting) {
              newData = Object.assign(newData, {
                production_date: order_detail.production_date,
                expired_date: order_detail.expired_date,
              });
            }
            //判断是否开启库区
            if (
              this.settings &&
              this.settings.stock_area_enable &&
              this.stock &&
              this.stock.stock_area
            ) {
              submitOrderDetails.stock_area_id = order_detail.stock_area_id;
            }

            submitOrderDetails.stock_take_history_details.push(newData);
          });

          return submitOrderDetails;
        }
      }
    },

    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      if (this.mode == "regularNew") {
        //普通盘点导入
        StockTakeOrders.importCommonTemplate(this.excelFile, this.stock_id)
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.info(
                  i18n.t("Import.success", [
                    i18n.t("StockTakeOrders.ObjectName"),
                  ])
                );
                this.ImportDialog = false;
                var id = response.data.stock_take_history.id;
                this.$router.push("/stock-take-orders/" + id + "/stockTake");
              }
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          )
          .catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      } else if (this.mode == "batchNew") {
        //批次盘点导入
        StockTakeOrders.importBatchTemplate(this.excelFile, this.stock_id)
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.info(
                  i18n.t("Import.success", [
                    i18n.t("StockTakeOrders.batchStockStakeOrder"),
                  ])
                );
                this.ImportDialog = false;
                var id = response.data.stock_take_history.id;
                this.$router.push("/stock-take-orders/" + id + "/stockTake");
              }
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          )
          .catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      } else if (this.mode == "new") {
        //库位批次盘点导入
        StockTakeOrders.importPositionTemplate(this.excelFile, this.stock_id)
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.info(
                  i18n.t("Import.success", [
                    i18n.t("StockTakeOrders.positionStockStakeOrder"),
                  ])
                );
                this.ImportDialog = false;
                var id = response.data.stock_take_history.id;
                this.$router.push("/stock-take-orders/" + id + "/stockTake");
              }
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          )
          .catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      }
    },
    formatUnit(count, rate, unit, bigUnit, isBaseUnit = false) {
      let remainder = count % rate;
      let formatUnit = "";
      if (remainder == 0 || rate == 1) {
        formatUnit = count / rate + bigUnit;
      } else {
        formatUnit = i18n.t("Stock.stockQuantityWithMultipleUnits", [
          parseInt(count / rate),
          bigUnit,
          this.$numberFormatter.formatTwoDot(count % rate),
          unit,
        ]);
      }
      if (isBaseUnit) {
        formatUnit = formatUnit + "(" + count + unit + ")";
      }
      return formatUnit;
    },
    // 整理提交数据
    // submitData() {
    //   //过滤没有盘点量的详情
    //   var submitOrderDetails = {
    //     stock_id: this.stock_id,
    //     operate_user_id: this.operate_user_id,
    //     stock_take_history_details: [],
    //   };
    //   if (this.isNew && !this.preview) {
    //     //提交到预览
    //     let orderDetails = this.stockTakeOrderDetails.filter(
    //       (detail) =>
    //         detail.real_count ||
    //         detail.real_count_rate ||
    //         detail.real_count_default
    //     );
    //     if (orderDetails.length) {
    //       orderDetails.forEach((order_detail) => {
    //         //计算总盘点量
    //         let real_count = "";
    //         if (order_detail.real_count_rate) {
    //           if (this.mode == "new" && !order_detail.isNewMaterial) {
    //             real_count =
    //               order_detail.real_count_rate *
    //               order_detail.stock_material_position.stock_material
    //                 .standard_detail.rate;
    //           } else {
    //             real_count =
    //               order_detail.real_count_rate *
    //               order_detail.standard_detail.rate;
    //           }

    //           if (order_detail.real_count_default)
    //             real_count += order_detail.real_count_default;
    //         } else if (
    //           order_detail.real_count ||
    //           order_detail.real_count_default
    //         ) {
    //           order_detail.real_count
    //             ? (real_count = order_detail.real_count)
    //             : order_detail.real_count_default
    //             ? (real_count = order_detail.real_count_default)
    //             : "";
    //         }

    //         //添加详情
    //         let newData = null;
    //         if (this.isNew && this.mode == "new") {
    //           if (order_detail.isNewMaterial) {
    //             newData = Object.assign(
    //               {},
    //               {
    //                 real_count: real_count,
    //                 material_code: order_detail.material_code,
    //                 price: order_detail.price,
    //                 stock_position_id: order_detail.stock_material_position.id,
    //               }
    //             );
    //           } else {
    //             newData = Object.assign(
    //               {},
    //               {
    //                 real_count: real_count,
    //                 material_code: order_detail.material_code,
    //                 stock_detail_id: order_detail.stock_detail.id,
    //                 price: order_detail.price,
    //                 stock_position_id:
    //                   order_detail.stock_material_position.stock_position_id,
    //               }
    //             );
    //           }
    //         } else if (this.isNew && this.mode == "batchNew") {
    //           newData = Object.assign(
    //             {},
    //             {
    //               real_count: real_count,
    //               material_code: order_detail.material_code,
    //               stock_detail_id: order_detail.stock_detail.id,
    //               price: order_detail.price,
    //             }
    //           );
    //         } else if (this.isNew && this.mode == "regularNew") {
    //           newData = Object.assign(
    //             {},
    //             {
    //               real_count: real_count,
    //               material_code: order_detail.material_code,
    //               price: order_detail.price,
    //             }
    //           );
    //         }

    //         //判断是否开启生产过期日期
    //         if (this.settings && this.settings.product_date_setting) {
    //           if (
    //             (this.mode == "new" && !order_detail.isNewMaterial) ||
    //             this.mode == "batchNew"
    //           ) {
    //             newData.production_date =
    //               order_detail.stock_detail.production_date;
    //             newData.expired_date = order_detail.stock_detail.expired_date;
    //           } else if (this.mode == "regularNew") {
    //             let stock_take_in = this.stockTakeHistoryDetails.stockTakeIns
    //               ? this.stockTakeHistoryDetails.stockTakeIns.find(
    //                   (inDetail) =>
    //                     inDetail.material_code == order_detail.material_code
    //                 )
    //               : null;
    //             if (stock_take_in) {
    //               newData.production_date = stock_take_in.production_date;
    //               newData.expired_date = stock_take_in.expired_date;
    //             }
    //           }
    //         }
    //         //判断是否开启库区
    //         if (
    //           this.settings &&
    //           this.settings.stock_area_enable &&
    //           this.stock &&
    //           this.stock.stock_area
    //         ) {
    //           submitOrderDetails.stock_area_id = order_detail.stock_area_id;
    //         }

    //         submitOrderDetails.stock_take_history_details.push(newData);
    //       });

    //       return submitOrderDetails;
    //     } else {
    //       this.$snackbar.error(i18n.t("StockTakeOrders.toPreviewErrorMsg"));
    //     }
    //   } else if (this.isNew && this.preview) {
    //     //提交生成盘点单
    //     if (this.stockTakeHistoryDetails.stockTakeIns.length) {
    //       this.stockTakeHistoryDetails.stockTakeIns.forEach((in_detail) => {
    //         let newData = {};
    //         if (this.isNew && this.mode == "new") {
    //           newData = Object.assign(
    //             {},
    //             {
    //               real_count: in_detail.real_count,
    //               material_code: in_detail.material_code,
    //               price: in_detail.price,
    //               stock_detail_id: in_detail.stock_detail_id,
    //               stock_position_id: in_detail.stock_position_id,
    //             }
    //           );
    //         } else if (this.isNew && this.mode == "batchNew") {
    //           newData = Object.assign(
    //             {},
    //             {
    //               real_count: in_detail.real_count,
    //               material_code: in_detail.material_code,
    //               price: in_detail.price,
    //               stock_detail_id: in_detail.stock_detail_id,
    //             }
    //           );
    //         } else if (this.isNew && this.mode == "regularNew") {
    //           newData = Object.assign(
    //             {},
    //             {
    //               real_count: in_detail.real_count,
    //               material_code: in_detail.material_code,
    //               price: in_detail.price,
    //             }
    //           );
    //         }

    //         //判断是否开启生产过期日期
    //         if (this.settings && this.settings.product_date_setting) {
    //           newData.production_date = in_detail.production_date;
    //           newData.expired_date = in_detail.expired_date;
    //         }

    //         //判断是否开启库区
    //         if (
    //           this.settings &&
    //           this.settings.stock_area_enable &&
    //           in_detail.stock_area
    //         ) {
    //           submitOrderDetails.stock_area_id = in_detail.stock_area.id;
    //         }

    //         submitOrderDetails.stock_take_history_details.push(newData);
    //       });
    //     }
    //     if (this.stockTakeHistoryDetails.stockTakeOuts.length) {
    //       this.stockTakeHistoryDetails.stockTakeOuts.forEach((out_detail) => {
    //         let newData = {};
    //         if (this.isNew && this.mode == "new") {
    //           newData = Object.assign(
    //             {},
    //             {
    //               real_count: out_detail.real_count,
    //               material_code: out_detail.material_code,
    //               price: out_detail.price,
    //               stock_detail_id: out_detail.stock_detail_id,
    //               stock_position_id: out_detail.stock_position_id,
    //             }
    //           );
    //         } else if (this.isNew && this.mode == "batchNew") {
    //           newData = Object.assign(
    //             {},
    //             {
    //               real_count: out_detail.real_count,
    //               material_code: out_detail.material_code,
    //               price: out_detail.price,
    //               stock_detail_id: out_detail.stock_detail_id,
    //             }
    //           );
    //         } else if (this.isNew && this.mode == "regularNew") {
    //           newData = Object.assign(
    //             {},
    //             {
    //               real_count: out_detail.real_count,
    //               material_code: out_detail.material_code,
    //               price: out_detail.price,
    //             }
    //           );
    //         }

    //         //判断是否开启生产过期日期
    //         if (this.settings && this.settings.product_date_setting) {
    //           newData.production_date = out_detail.production_date;
    //           newData.expired_date = out_detail.expired_date;
    //         }

    //         //判断是否开启库区
    //         if (
    //           this.settings &&
    //           this.settings.stock_area_enable &&
    //           out_detail.stock_area
    //         ) {
    //           submitOrderDetails.stock_area_id = out_detail.stock_area.id;
    //         }

    //         submitOrderDetails.stock_take_history_details.push(newData);
    //       });
    //     }

    //     return submitOrderDetails;
    //   }
    // },
  },

  watch: {
    $route(to) {
      if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/stock-take-orders/" + to.params.id);
      }
    },
    mode: {
      handler() {
        if (this.isNew) {
          this.stockTakeOrder = {
            stock_order_details: [],
          };
        } else if (this.$route.params.id) {
          this.getStockInsFromAPI();
        }
      },
    },
    accountUser: {
      handler() {
        this.executeUser = this.accountUser ? this.accountUser : null;
      },
    },
    stockTakeOrder: {
      handler() {
        this.stockTakeOrderDetails =
          this.stockTakeOrder && this.stockTakeOrder.stock_take_history_details
            ? this.stockTakeOrder.stock_take_history_details
            : [];
        this.stock =
          this.stockTakeOrder && this.stockTakeOrder.stock
            ? this.stockTakeOrder.stock
            : {};
      },
    },
    stockTakeOrderDetails: {
      handler() {
        this.stockTakeOrderDetails.map((detail) => {
          detail.Description = i18n.t(
            this.settings
              ? this.settings.material_name_display_type == 3
                ? "Material.materialNameWithCodeAndStandard"
                : this.settings.material_name_display_type == 2
                ? "Material.materialNameWithCode"
                : "Material.materialName"
              : "Material.materialName",
            [
              detail.material_code,
              detail.material_name,
              detail.new ? detail.standard_name : detail.standard_name,
            ]
          );
        });
        //普通盘点
        if (this.mode == "regularNew") {
          this.stockTakeOrderDetails.forEach((detail) => {
            var isFind = this.disabledItems.findIndex(
              (item) => item.material_id == detail.material_id
            );
            if (isFind == -1) {
              this.disabledItems.push(detail);
            }
          });
          //清空商品select
          if (this.addMaterial) {
            this.addMaterial = {};
          }
          if (this.selectMaterial) {
            this.selectMaterial = null;
          }
        }
      },
    },
    stockSelected: {
      handler() {
        if (this.stockSelected && this.stockSelected.id) {
          // this.$store.dispatch("fullscreenLoading");
          Stocks.fetchOne(this.stockSelected.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                // this.$store.dispatch("fullscreenLoadingStop");
                this.stock = response.data.stock;
                if (
                  this.stock.stock_take_type &&
                  this.stock.stock_take_type.length == 1
                ) {
                  if (this.stock.stock_take_type[0] == 1) {
                    this.stock_take_type = 1;
                    this.type = 1;
                  } else if (this.stock.stock_take_type[0] == 2) {
                    this.stock_take_type = 2;
                    this.type = 2;
                  }
                } else if (
                  this.stock.stock_take_type &&
                  this.stock.stock_take_type.length == 2
                ) {
                  this.stock_take_type = 3;
                  this.type = 1;
                } else {
                  this.stock_take_type = 0;
                  this.type = 0;
                }
              }
            }.bind(this)
          );
          if (this.mode == "batchNew") {
            //获取当前仓库下是否有未使用的批次
            StockDetails.fetch({
              stock_ids: [this.stockSelected.id],
              status: [0, 2],
            }).then(
              function (response) {
                if (response.data.status.isOK()) {
                  if (!response.data.stock_details.length) {
                    this.stockDetailsNullDialog = true;
                    this.stockDetailsNullMsg = i18n.t(
                      "StockTakeOrders.stockDetailsNull"
                    );
                  }
                }
              }.bind(this)
            );
          }
        }
      },
    },
    stockAreaSelected: {
      handler() {
        this.stockPositionSelected = null;
        if (this.stockAreaSelected) {
          StockPosition.fetchAllForSelect({
            stock_id: this.stock_id,
            exist_material: 1,
            stock_area_id: this.stockAreaSelected.id,
          }).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.stockPosition = response.data.stock_positions;
              }
            }.bind(this)
          );
        }
      },
    },
    stockPositionSelected: {
      handler() {
        if (
          !this.stockPositionSelected &&
          this.addPositionMaterialSelected &&
          this.addPositionMaterialSelected.id
        ) {
          this.addPositionMaterialSelected = null;
        }
      },
    },
    addPositionMaterialSelected: {
      handler() {
        if (
          this.addPositionMaterialSelected &&
          this.addPositionMaterialSelected.id
        ) {
          if (!this.addPositionMaterialSelected.isNewMaterial) {
            this.stockBatchDialog = true;
          } else {
            var newData = {
              new: this.stockTakeOrderDetails.length + 1,
              isNewMaterial: 1,
              material_id: this.addPositionMaterialSelected.material_id,
              material_code: this.addPositionMaterialSelected.material_code,
              material_name: this.addPositionMaterialSelected.material_name,
              price: 0,
              unit: this.addPositionMaterialSelected.unit,
              standard_name: this.addPositionMaterialSelected.standard.name,
              category_name: this.addPositionMaterialSelected.category_name,
              stock_material_position: this.stockPositionSelected,
              standard_detail: this.addPositionMaterialSelected.standard_detail,
              default_standard_detail:
                this.addPositionMaterialSelected.default_standard_detail,
            };
            if (
              this.settings &&
              this.settings.stock_area_enable &&
              this.stock &&
              this.stock.stock_area
            ) {
              newData.stock_area_id = this.stockAreaSelected
                ? this.stockAreaSelected.id
                : "";
              newData.stock_area_name = this.stockAreaSelected
                ? this.stockAreaSelected.area_name
                : "";
            }

            //添加新商品
            this.stockTakeOrderDetails.push(newData);
            this.addPositionMaterialSelected = null;
            this.stockPositionSelected = null;
            this.stockAreaSelected = null;
          }
        }
      },
    },
    stockBatchSeleted: {
      handler() {
        if (this.stockBatchSeleted.length) {
          this.stockBatchSeleted.forEach((selectedData) => {
            var isFind = this.stockTakeOrderDetails.findIndex(
              (detail) =>
                detail.stock_batch_code == selectedData.stock_batch_code
            );
            if (isFind == -1) {
              var stockDetail = JSON.parse(JSON.stringify(selectedData));
              //库位批次盘点
              if (this.mode == "new") {
                delete stockDetail.material;
                var stockPosition = JSON.parse(
                  JSON.stringify(stockDetail.stock_material_position)
                );
                delete stockDetail.stock_material_position;

                var newData = {
                  new: this.stockTakeOrderDetails.length + 1,
                  material_id: selectedData.material.id,
                  material_code: selectedData.material.material_code,
                  material_name: selectedData.material.material_name,
                  price: selectedData.price,
                  standard_name: selectedData.material.standard.name,
                  category_name: selectedData.material.material_category.name,
                  stock_detail: stockDetail,
                  stock_material_position: stockPosition,
                };
                if (
                  this.settings &&
                  this.settings.stock_area_enable &&
                  this.stock &&
                  this.stock.stock_area
                ) {
                  newData.stock_area_id = this.stockAreaSelected
                    ? this.stockAreaSelected.id
                    : "";
                  newData.stock_area_name = this.stockAreaSelected
                    ? this.stockAreaSelected.area_name
                    : "";
                }

                this.stockTakeOrderDetails.push(newData);
              } else if (this.mode == "batchNew") {
                //批次盘点
                delete stockDetail.material;
                delete stockDetail.stock;
                this.stockTakeOrderDetails.push({
                  new: this.stockTakeOrderDetails.length + 1,
                  material_id: selectedData.material_id,
                  material_code: selectedData.material.material_code,
                  material_name: selectedData.material.material_name,
                  category_name: selectedData.material.material_category.name,
                  price: selectedData.price,
                  stock_batch_code: selectedData.stock_batch_code,
                  production_date: selectedData.production_date,
                  expired_date: selectedData.expired_date,
                  stock_detail: stockDetail,
                  standard_detail: this.addMaterial.standard_detail,
                  default_standard_detail:
                    this.addMaterial.default_standard_detail,
                  unit: this.addMaterial.unit,
                  standard_name: this.addMaterial.standard_name,
                });
              }
            }
          });
        }
      },
    },
    stockBatchDialog: {
      handler() {
        if (!this.stockBatchDialog) {
          if (this.stockBatchSelected) this.stockBatchSelected = [];
          if (this.mode == "new" && this.addPositionMaterialSelected) {
            this.addPositionMaterialSelected = null;
            this.stockPositionSelected = null;
            this.stockAreaSelected = null;
          }
          if (this.mode == "batchNew" && this.addMaterial) {
            this.addMaterial = {};
            this.selectMaterial = null;
          }
        } else {
          if (this.mode == "new" && this.addPositionMaterialSelected) {
            //默认勾选已选的批次
            this.stockTakeOrderDetails.forEach((detail) => {
              if (detail.material_id == this.addPositionMaterialSelected.id) {
                this.stockBatchSeletedId.push({ id: detail.stock_detail.id });
              }
            });
          }
          if (this.mode == "batchNew" && this.addMaterial) {
            //默认勾选已选的批次
            this.stockTakeOrderDetails.forEach((detail) => {
              if (detail.material_id == this.addMaterial.material_id) {
                this.stockBatchSeletedId.push({ id: detail.stock_detail.id });
              }
            });
          }
        }
      },
    },
    lossStockBatchSelected: {
      handler() {
        this.stockTakeHistoryDetails.stockTakeOuts.forEach((detail) => {
          if (detail.material_id == this.currentItem.material_id) {
            let stock_detail_ids = [];
            this.lossStockBatchSelected.forEach((stockBatch) => {
              stock_detail_ids.push(stockBatch.id);
            });
            this.$set(detail, "stock_detail_ids", stock_detail_ids);
            if (stock_detail_ids && stock_detail_ids.length > 0) {
              this.$set(detail, "price", "");
            }
          }
        });
      },
    },
    selectMaterial: {
      handler() {
        if (this.selectMaterial && this.selectMaterial.id) {
          let postData = {
            stock_id: this.stock_id,
            readonly: 0,
            material_ids: this.selectMaterial.material_id,
            material_code: this.selectMaterial.material_code,
          };
          if (this.type == 2 && this.mode == "regularNew") {
            postData = Object.assign({}, postData, { delete_stock_count: 1 });
          }
          StockMaterials.fetchAllForSelect(postData).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.addMaterial = response.data.materials[0];
              }
            }.bind(this)
          );
        }
      },
    },
    selectMaterials: {
      handler() {
        if (this.selectMaterials && this.selectMaterials.length) {
          let postData = {
            stock_id: this.stock_id,
            readonly: 0,
            material_ids: this.selectMaterials.map(
              (selectMaterial) => selectMaterial.material_id
            ),
          };
          if (this.type == 2 && this.mode == "regularNew") {
            postData = Object.assign({}, postData, { delete_stock_count: 1 });
          }
          StockMaterials.fetchAllForSelect(postData).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.addMaterials = response.data.materials;
              }
            }.bind(this)
          );
        }
      },
    },
    addMaterial: {
      handler() {
        if (Object.keys(this.addMaterial).length) {
          if (this.mode == "regularNew") {
            var newData = JSON.parse(JSON.stringify(this.addMaterial));
            newData.price =
              newData.current_count == 0
                ? 0
                : parseFloat(
                    newData.total_price / newData.current_count
                  ).toFixed(2);
            newData.new = this.stockTakeOrderDetails.length + 1;
            let default_unit = "";
            newData.standard_details.forEach((detail) => {
              if (detail.default_flg == 1) {
                default_unit = detail.unit;
              }
            });
            newData.default_unit_count = newData.current_count + default_unit;

            this.stockTakeOrderDetails.push(newData);
          } else if (this.mode == "batchNew") {
            this.stockBatchDialog = true;
          }
        }
      },
    },
    addMaterials: {
      handler() {
        if (this.addMaterials && this.addMaterials.length) {
          this.addMaterials.forEach((addMaterial) => {
            if (Object.keys(addMaterial).length) {
              if (this.mode == "regularNew") {
                var newData = JSON.parse(JSON.stringify(addMaterial));
                newData.price =
                  newData.current_count == 0
                    ? 0
                    : parseFloat(
                        newData.total_price / newData.current_count
                      ).toFixed(2);
                newData.new = this.stockTakeOrderDetails.length + 1;
                let default_unit = "";
                newData.standard_details.forEach((detail) => {
                  if (detail.default_flg == 1) {
                    default_unit = detail.unit;
                  }
                });
                newData.default_unit_count =
                  newData.current_count + default_unit;

                this.stockTakeOrderDetails.push(newData);
              } else if (this.mode == "batchNew") {
                this.stockBatchDialog = true;
              }
            }
          });
        }
      },
    },
    ImportDialog: {
      handler() {
        if (!this.ImportDialog && this.excelFile) {
          this.excelFile = null;
        }
      },
    },
    // !detail.expired_date &&
    stockTakeHistoryDetails: {
      deep: true,
      handler() {
        this.stockTakeHistoryDetails.stockTakeIns.forEach((detail) => {
          if (
            this.settings &&
            this.settings.product_date_setting &&
            Number(detail.bestbefore) &&
            detail.production_date &&
            !detail.stock_detail_id
          ) {
            detail.expired_date = new Date(
              new Date(detail.production_date).getTime() +
                Number(detail.bestbefore) * 24 * 3600 * 1000
            )
              .toISOString()
              .substr(0, 10);
          }
        });
      },
    },
  },
};
</script>